import React from 'react';
import './Header.css';
import { NavLink, useLocation } from 'react-router-dom';

export const HeaderMobile: React.FC = () => {
  const location = useLocation();

  const onLogoClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    // If we're already on the home page, reload it
    if (location.pathname === '/') {
      e.preventDefault();
      window.location.reload();
    }
    // Otherwise, let React Router handle the navigation normally
  };

  return (
    <div className='laptop:hidden flex flex-col px-app-base justify-center sticky z-10  top-0 '>
      <div className='flex flex-1 bg-app-card px-app-lg py-app-base rounded-b-app-base'>
        <NavLink to={'/'} className='w-[200px] ' onClick={onLogoClick} >
          <img src="/logo-new.png" alt="" />
        </NavLink>
      </div>
    </div>
  );
};